export default __webpack_public_path__ + "static/media/Musashi.627128a9.otf";